module.exports = __webpack_public_path__ + "01a75a64039feb08190ee2ae0a261112.woff2";